module.exports = __webpack_public_path__ + "img/sun.f23a144.svg";